import React, { useContext, useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Info from "../../assets/images/icons/info.png";
// import Slider from "./DistanceSilder";
import { Slider } from "antd";

import MovePlannerContext from "../../context/move_planner/movePlanner";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import {
  // isValidPincode,
  onlyNumber,
  maxFloorNumber,
} from "../common/validationFn";

export default function OldHouseDetails(props) {
  const propertyInfo = useSelector((state) => state.propertyInfo);
  const moveInfo = useSelector((state) => state.moveInfo);
  const houseAddress = prepopulateHouseAddress();
  const houseLocation = prepopulateHouseLocation();

  const houseCity = prepopulateHouseCity();
  // const houseAddress = propertyInfo.oldHouseAddress;
  // const houseLocation = propertyInfo.oldHouseLocation;
  // const houseCity = propertyInfo.oldHouseCity;
  const houseState = prepopulateHouseState();
  const housePincode = propertyInfo.oldHousePincode;
  const houseDistance = propertyInfo.oldHouseDistance;
  const floorNumber = propertyInfo.oldFloorNumber;
  // const updateFloorNumber = props.floorInfo.setOldFloorNumber;
  const elevatorStatus = props.elevatorInfo.oldHasElevator;
  const updateElevatorStatus = props.elevatorInfo.setOldHasElevator;
  const distanceUnit = props.distanceUnit.oldDistanceUnit;
  const updateDistanceUnit = props.distanceUnit.setOldDistanceUnit;
  const [distanceSettings, setDistanceSettings] = useState(getInitSettings());

  const context = useContext(MovePlannerContext);
  const { register, errors, control, getValues, setValue } =
    context.estimateForm.usePropertyInfoForm;

  const formatter = (value) => parseInt(value);

  // const floorNumberWatch = watch("old_house_floor_number");

  function getInitSettings() {
    if (distanceUnit === "meters") {
      return {
        min: 0,
        max: 100,
        step: 1,
      };
    }
    if (distanceUnit === "feet") {
      return {
        min: 0,
        max: 328.084,
        step: 0.01,
      };
    }
  }

  const incrementFloorNumberFn = () => {
    const floorNumber = parseInt(getValues("old_house_floor_number"));

    if (floorNumber === "") {
      // updateFloorNumber(0);
      setValue("old_house_floor_number", 0);
      return;
    }
    if (floorNumber >= 300) {
      return;
    }
    setValue("old_house_floor_number", parseInt(floorNumber) + 1);
    // updateFloorNumber((number) => parseInt(number) + 1);
  };
  const decrementFloorNumberFn = () => {
    const floorNumber = parseInt(getValues("old_house_floor_number"));

    if (floorNumber === "") {
      // updateFloorNumber(0);
      setValue("old_house_floor_number", 0);
      return;
    }
    if (floorNumber === 0) {
      return;
    }
    setValue("old_house_floor_number", parseInt(floorNumber) - 1);

    // updateFloorNumber((number) => parseInt(number) - 1);
  };

  function getFormattedAddressList() {
    return moveInfo[
      moveInfo.moveType === "Within City"
        ? "withinCityMovingFrom"
        : "interCityMovingFrom"
    ]
      .split(",")
      .reverse();
  }

  function prepopulateHouseAddress() {
    if (propertyInfo.oldHouseAddress === "") {
      const address = getFormattedAddressList();
      const addressIndexValue = address[3];
      if (addressIndexValue !== undefined) {
        var addressValue = [];
        for (var addr = address.length - 1; addr >= 3; addr--) {
          addressValue.push(address[addr]);
        }
        return addressValue.join(",");
      }
      return "";
    }
    return propertyInfo.oldHouseAddress;
  }

  function prepopulateHouseLocation() {
    if (propertyInfo.oldHouseLocation === "") {
      const address = getFormattedAddressList();
      const addressIndexValue = address[2];
      if (addressIndexValue !== undefined) {
        return addressIndexValue;
      }
      return "";
    }
    return propertyInfo.oldHouseLocation;
  }
  function prepopulateHouseCity() {
    if (propertyInfo.oldHouseCity === "") {
      const address = getFormattedAddressList();
      const addressIndexValue = address[1];
      if (addressIndexValue !== undefined) {
        return addressIndexValue;
      }
    }
    return propertyInfo.oldHouseCity;
  }
  function prepopulateHouseState() {
    if (propertyInfo.oldHouseState === "") {
      const address = getFormattedAddressList();
      const addressIndexValue = address[0];
      if (addressIndexValue !== undefined) {
        return addressIndexValue;
      }
    }
    return propertyInfo.oldHouseState;
  }
  // const updateDistanceSettings = (unit) => {
  //   var distance = getValues("old_house_distance");
  //   const rangePreset = distanceSettings;
  //   if (unit === "meters") {
  //     //convert feet to meters
  //     distance = parseFloat(distance / 3.281);
  //     distance = distance.toFixed(2);
  //     rangePreset.min = 0;
  //     rangePreset.max = 100;
  //     rangePreset.step = 1;
  //   } else if (unit === "feet") {
  //     // convert meters to feet
  //     distance = parseFloat(distance * 3.281);
  //     distance = distance.toFixed(2);
  //     rangePreset.min = 0;
  //     rangePreset.max = 328.084;
  //     //100m = 328.084ft max value
  //     rangePreset.step = 0.01;
  //   }
  //   updateDistanceUnit(unit);
  //   setValue("old_house_distance", distance);
  //   setDistanceSettings(rangePreset);
  // };

  useEffect(() => {
    setValue("old_house_distance", houseDistance);
  }, [houseDistance, setValue]);
  useEffect(() => {
    setValue("old_house_floor_number", floorNumber);
  }, [floorNumber, setValue]);
  useEffect(() => {
    if (propertyInfo.oldHouseDistanceUnit === "meters") {
      setDistanceSettings({
        min: 0,
        max: 100,
        step: 1,
      });
    } else if (propertyInfo.oldHouseDistanceUnit === "feet") {
      setDistanceSettings({
        min: 0,
        max: 328.084,
        step: 0.01,
      });
    }
    updateDistanceUnit(propertyInfo.oldHouseDistanceUnit);
    return;
  }, [
    propertyInfo.oldHouseDistanceUnit,
    setDistanceSettings,
    updateDistanceUnit,
  ]);
  const validRequired = (value) => {
    return value.trim() === "" ? false : true;
  };
  const JSX = (
    <div className="row mt-4">
      <div className="col-12 house-detials-container">
        <h2> From house details </h2>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label className="form-label">
                House Address <span className="text-danger">*</span>{" "}
              </label>
              <textarea
                name="old_house_address"
                id=""
                cols="30"
                rows="2"
                defaultValue={houseAddress}
                className="form-control"
                placeholder="Ex. #23, Street number, Door No, Locality..."
                ref={register({
                  required: true,
                  validate: {
                    validAddress: (address) => {
                      const regex = new RegExp(/^[a-zA-Z 0-9,-@./#\r\n()]*$/);
                      return regex.test(address);
                    },
                    validRequired: validRequired,
                    hasAlphabets: (value) => {
                      const regex = new RegExp(/(.*[a-zA-Z]){3}/i);
                      return regex.test(value);
                    },
                  },
                })}
              ></textarea>
              <label className="select_city-error error-text">
                {errors.old_house_address &&
                  errors.old_house_address.type === "required" && (
                    <> Required </>
                  )}
                    {errors.old_house_address &&
                  errors.old_house_address.type === "hasAlphabets" && (
                    <> Please enter atleast 3 alphabets. </>
                  )}
                {errors.old_house_address &&
                  errors.old_house_address.type === "validAddress" && (
                    <>
                      {" "}
                      Please enter valid address. allowed special characters
                      [/,#,-,@,(,),.]{" "}
                    </>
                  )}
                {errors.old_house_address &&
                  errors.old_house_address.type === "validRequired" && (
                    <> Required </>
                  )}
              </label>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-6">
            <div className="form-group mb-0">
              <label className="form-label mb-0">
                Locality <span className="text-danger">*</span>
              </label>
              <input
                name="old_house_location"
                type="text"
                defaultValue={houseLocation}
                ref={register({
                  required: true,
                  validate: {
                    validInput: (address) => {
                      const regex = new RegExp(/^[a-zA-Z .]*$/);
                      return regex.test(address);
                    },
                    validRequired: validRequired,
                    minLengthInput: (value) => {
                      return value.length < 3 ? false : true;
                    },
                    hasAlphabets: (value) => {
                      const regex = new RegExp(/(.*[a-zA-Z]){3}/i);
                      return regex.test(value);
                    },
                  },
                })}
                className="form-control"
              />
              <label className="select_city-error error-text">
                {errors.old_house_location &&
                  errors.old_house_location.type === "required" && (
                    <> Required </>
                  )}
                {errors.old_house_location &&
                  errors.old_house_location.type === "validRequired" && (
                    <> Required </>
                  )}
                {errors.old_house_location &&
                  errors.old_house_location.type === "hasAlphabets" && (
                    <> Please enter atleast 3 alphabets. </>
                  )}
                {errors.old_house_location &&
                  errors.old_house_location.type === "validInput" && (
                    <>Please enter only alphabets</>
                  )}
                {errors.old_house_location &&
                  errors.old_house_location.type === "minLengthInput" && (
                    <>Minimum 3 characters required. </>
                  )}
              </label>
            </div>
          </div>
          <div className="col-sm-12 col-md-6">
            <div className="form-group mb-0">
              <label className="form-label mb-0">
                City <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="old_house_city"
                defaultValue={houseCity}
                ref={register({
                  validate: {
                    validRequired: validRequired,
                    validInput: (address) => {
                      const regex = new RegExp(/^[a-zA-Z ]*$/);
                      return regex.test(address);
                    },
                    minLengthInput: (value) => {
                      return value.length < 3 ? false : true;
                    },
                  },
                })}
                className="form-control"
              />
              <label className="select_city-error error-text">
                {errors.old_house_city &&
                  errors.old_house_city.type === "required" && <> Required </>}
                {errors.old_house_city &&
                  errors.old_house_city.type === "validRequired" && (
                    <>Required </>
                  )}
                {errors.old_house_city &&
                  errors.old_house_city.type === "minLengthInput" && (
                    <>Minimum 3 characters required. </>
                  )}
                {errors.old_house_city &&
                  errors.old_house_city.type === "validInput" && (
                    <>Please enter only alphabets</>
                  )}
              </label>
            </div>
          </div>
          <div className="col-sm-4 col-md-6">
            <div className="form-group mb-0">
              <label className="form-label mb-0">
                State <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="old_house_state"
                defaultValue={houseState}
                ref={register({
                  required: true,
                  validate: {
                    validInput: (address) => {
                      const regex = new RegExp(/^[a-zA-Z ]*$/);
                      return regex.test(address);
                    },
                    validRequired: validRequired,
                    minLengthInput: (value) => {
                      return value.length < 3 ? false : true;
                    },
                  },
                })}
                className="form-control"
              />
              <label className="select_city-error error-text">
                {errors.old_house_state &&
                  errors.old_house_state.type === "required" && <> Required </>}
                {errors.old_house_state &&
                  errors.old_house_state.type === "validRequired" && (
                    <> Required </>
                  )}
                {errors.old_house_state &&
                  errors.old_house_state.type === "validInput" && (
                    <>Please enter only alphabets</>
                  )}
                {errors.old_house_state &&
                  errors.old_house_state.type === "minLengthInput" && (
                    <>Minimum 3 characters required. </>
                  )}
              </label>
            </div>
          </div>
          <div className="col-sm-4 col-md-6" style={{display:"none"}}>
            <div className="form-group mb-0">
              <label className="form-label mb-0">
                Pincode <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="old_house_pincode"
                defaultValue={housePincode}
                // ref={register({
                //   required: true,
                //   validate: {
                //     isValidPincode: isValidPincode,
                //     validRequired: validRequired,
                //   },
                // })}
                ref={register()}
                className="form-control"
              />
              <label className="select_city-error error-text">
                {errors.old_house_pincode &&
                  errors.old_house_pincode.type === "required" && (
                    <> Required </>
                  )}
                {errors.old_house_pincode &&
                  errors.old_house_pincode.type === "validRequired" && (
                    <> Required </>
                  )}
                {errors.old_house_pincode &&
                  errors.old_house_pincode.type === "isValidPincode" && (
                    <> Please enter a valid pincode </>
                  )}
              </label>
            </div>
          </div>
        </div>
        <div className="row mb-2 floor-basic-info">
          
          <div className="col-sm-2 col-md-3 col-lg-8 col-xl-6">
            <div className="form-group mb-0">
              <label className="form-label">Service Lift Available? </label>
              <React.Fragment>
                <OverlayTrigger
                  key={"top"}
                  placement={"top"}
                  overlay={
                    <Tooltip id={`tooltip-${"top"}`}>
                      Is the elevator allowed to carry household goods?
                    </Tooltip>
                  }
                >
                  <img src={Info} className="img-fluid mx-1" alt="" />
                </OverlayTrigger>
              </React.Fragment>
              <></>
              <div>
                <div
                  className="btn-group btn-group-toggle"
                  data-toggle="buttons"
                >
                  <label
                    className={
                      "btn btn-primary btn-sm yes-btn" +
                      (elevatorStatus === "Yes" ? " active" : "")
                    }
                  >
                    <input
                      type="radio"
                      name="old_elevator_availability"
                      value="Yes"
                      autoComplete="off"
                      onChange={(e) => {
                        updateElevatorStatus("Yes");
                        setValue("old_house_floor_number", 0);
                        
                      }}
                      checked={elevatorStatus === "Yes" ? true : false}
                    />
                    Yes
                  </label>
                  <label
                    className={
                      "btn btn-primary btn-sm no-btn" +
                      (elevatorStatus === "No" ? " active" : "")
                    }
                  >
                    <input
                      type="radio"
                      name="old_elevator_availability"
                      value="No"
                      autoComplete="off"
                      onChange={(e) => {
                        updateElevatorStatus("No");
                      }}
                      checked={elevatorStatus === "No" ? " active" : ""}
                    />
                    No
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-2 col-md-3 col-lg-4 col-xl-3" style={elevatorStatus === "Yes"?{visibility:"hidden"}:{}}>
            <div className="form-group mb-0">
              <label className="form-label">
                {" "}
                Floor No. <span className="text-danger">*</span>
              </label>
              <div className="floor-no w-20">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <button
                      type="button"
                      className="btn-sm clear-btn-white-theme"
                      onClick={decrementFloorNumberFn}
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </button>
                  </div>
                  <input
                    type="number"
                    min="0"
                    name="old_house_floor_number"
                    className="form-control text-center qty-input border-0"
                    defaultValue={floorNumber}
                    autoComplete="off"
                    id="old_floor_no"
                    ref={register({
                      required: true,
                      validate: {
                        onlyNumber: onlyNumber,
                        maxFloorNumber: maxFloorNumber,
                        validRequired: validRequired,
                      },
                    })}
                  />
                  <div className="input-group-append">
                    <button
                      className="btn-sm clear-btn-white-theme"
                      onClick={incrementFloorNumberFn}
                      type="button"
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </button>
                  </div>
                </div>
              </div>
              <label className="current_floor-error error-text m-0">
                {errors.old_house_floor_number &&
                  errors.old_house_floor_number.type === "required" &&
                  "Required"}
                {errors.old_house_floor_number &&
                  errors.old_house_floor_number.type === "validRequired" &&
                  "Required"}
                {errors.old_house_floor_number &&
                  errors.old_house_floor_number.type === "onlyNumber" &&
                  "please enter only numbers"}
                {errors.old_house_floor_number &&
                  errors.old_house_floor_number.type === "maxFloorNumber" &&
                  "please enter max 300"}
              </label>
            </div>
          </div>
          <div className="col-sm-2 col-md-12 col-lg-12 col-xl-12 house-distance-group">
            <div className="form-group mb-0">
              <label className="form-label old-house-dist-label">
                {elevatorStatus === "Yes" ? 
                  "Distance from Service Lift to truck"
                  : "Distance from Staircase / Home to truck"} {"(in meters)"}
              </label>
              <div className="d-flex align-items-center position-relative">
                <div id="existingHouseSlider" className="slider w-100">
                  <Controller
                    control={control}
                    name="old_house_distance"
                    defaultValue={houseDistance}
                    render={(props) => (
                      <Slider
                        min={distanceSettings.min}
                        max={distanceSettings.max}
                        onChange={props.onChange}
                        value={props.value}
                        step={distanceSettings.step}
                        disabled={false}
                        tooltipVisible={true}
                        tipFormatter={formatter}
                      />
                    )}
                  />
                </div>
                {/* <div
                  className="btn-group btn-group-toggle ml-4"
                  data-toggle="buttons"
                >
                  <label
                    className={
                      "btn btn-primary btn-sm yes-btn" +
                      (distanceUnit === "feet" ? " active" : "")
                    }
                  >
                    <input
                      type="radio"
                      name="old_parking_dist_unit"
                      className="existingDistanceFormat"
                      value="feet"
                      autoComplete="off"
                      checked={distanceUnit === "feet" ? true : false}
                      onChange={(e) => {
                        updateDistanceSettings("feet");
                        // props.handleUnitsUpdateForOldFloor(e);
                      }}
                    />
                    Ft
                  </label>
                  <label
                    className={
                      "btn btn-primary btn-sm no-btn" +
                      (distanceUnit === "meters" ? " active" : "")
                    }
                  >
                    <input
                      type="radio"
                      name="old_parking_dist_unit"
                      className="existingDistanceFormat"
                      value="meters"
                      autoComplete="off"
                      checked={distanceUnit === "meters" ? true : false}
                      onChange={(e) => {
                        // updateDistanceUnit("meters");
                        updateDistanceSettings("meters");

                        // props.handleUnitsUpdateForOldFloor(e);
                      }}
                    />
                    Mts
                  </label>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  return JSX;
}
